import {track} from '../../../utils/tracker';

/**
 * We need this method because merely importing these directly from twilio-video
 * might result in an error in some browsers, that we can't handle otherwise.
 * An example of this is the mobile version of the chrome inspector
 */
export const safelyLoadTwilio = () => {
  try {
    const {LocalVideoTrack, connect, createLocalTracks} = require('twilio-video');
    return {LocalVideoTrack, connect, createLocalTracks};
  } catch (e) {
    track('failed to load twilio');
    return {};
  }
};
